export function removeUnderscoresAndMakeFirstLetterCapital(str: string) {
  return str
    .replace(/_/g, ' ')
    .split(' ')
    .map((word) => {
      if (/^ace$/i.test(word)) {
        return 'ACE'
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    .join(' ')
}
